const FA_ZERO = '۰'.charCodeAt(0);
const AR_ZERO = '٠'.charCodeAt(0);

/** Convert Persian/Arabic numerals to ASCII and discard separators or other non-digits. */
export function moneyDigits(input: string): string {
  let result = '';
  for (const char of input) {
    const code = char.charCodeAt(0);
    if (code >= 48 && code <= 57) result += char;
    else if (code >= FA_ZERO && code <= FA_ZERO + 9) result += String(code - FA_ZERO);
    else if (code >= AR_ZERO && code <= AR_ZERO + 9) result += String(code - AR_ZERO);
  }
  return result.replace(/^0+(?=\d)/, '');
}

/** Render an editable toman amount with Persian digits and Persian thousands separators. */
export function formatMoneyInput(input: string): string {
  const digits = moneyDigits(input);
  if (!digits) return '';
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, '٬');
  return grouped.replace(/[0-9]/g, (digit) => String.fromCharCode(FA_ZERO + Number(digit)));
}

/** Parse a formatted amount exactly; wallet wire values are 64-bit integers and stay as bigint. */
export function parseMoneyInput(input: string): bigint {
  const digits = moneyDigits(input);
  return digits ? BigInt(digits) : 0n;
}
